import React from 'react';
import { Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { MODEL_VERSION_STATUSES } from '@shared/constants/model-registry-request-status';
import { Select, TextArea } from '@ds';
import classNames from './ModelVersionRequestStatusModal.module.scss';
import { KeyValueList } from './KeyValueList';
import { InfoIconWithTooltip } from '@design-system-outdated/components/InfoIconWithTooltip/InfoIconWithTooltip';

const RequestStatusForm = ({
  status,
  isWSOwnerOrHasMRPermission,
  setChangedStatus,
  statusConfiguration,
  setChangedStatusConfiguration,
  statusOptions,
  comment,
  setComment
}) => {
  return (
    <Box className={classNames.modalVersionRequestStatus}>
      <Box className={classNames.modalVersionRequestStatusLabel}>
        Select a status
      </Box>

      <Box
        className={classNames.modalVersionRequestStatusWrapper}
        data-test="modal-version-request-status-select"
      >
        <Select
          value={status || MODEL_VERSION_STATUSES.NA}
          onValueChange={value => setChangedStatus(value)}
          options={statusOptions}
          isSearchable={false}
          isClearable={false}
          hideSecondary
        />
      </Box>

      {!isWSOwnerOrHasMRPermission && (
        <Box mt={2} className={classNames.modalVersionRequestStatusLabel}>
          The &quot;Workspace Owner&quot; will need to approve your status
          change request
        </Box>
      )}

      {isWSOwnerOrHasMRPermission && (
        <Box mt={2} className={classNames.modalVersionRequestStatusLabel}>
          You can change the model status with or without submitting for review
        </Box>
      )}

      <Box className={classNames.modalVersionRequestStatusComment}>
        <Grid
          container
          alignContent="center"
          alignItems="center"
          style={{ marginBottom: '8px' }}
        >
          <Grid item style={{ marginRight: '4px' }}>
            Status Configuration
          </Grid>
          <Grid item>
            <InfoIconWithTooltip
              className={classNames.modelRegistryWebhooksInfoIcon}
              title="Status configuration will be included in the webhook payload and allows you to specify additional metadata."
            />
          </Grid>
        </Grid>
      </Box>
      <KeyValueList
        initialFields={statusConfiguration}
        onFieldsChange={setChangedStatusConfiguration}
        maxItemsAllowed={20}
      />
      <Box className={classNames.modalVersionRequestStatusComment}>
        <Grid container alignContent="center" alignItems="center">
          <Grid item style={{ marginRight: '4px' }}>
            Comment
          </Grid>
          <Grid item>
            <InfoIconWithTooltip
              className={classNames.modelRegistryWebhooksInfoIcon}
              title={
                isWSOwnerOrHasMRPermission ? (
                  <div>
                    <div>All model changes will be</div>
                    <div>reflected in History tab</div>
                  </div>
                ) : (
                  'Comments will be sent along with your request and be reflected in History Tab'
                )
              }
            />
          </Grid>
        </Grid>
      </Box>

      <Box className={classNames.modalVersionRequestStatusCommentInput}>
        <TextArea
          placeholder="Enter changes ..."
          multiline
          value={comment}
          onChange={e => setComment(e.target.value)}
          height="80px"
        />
      </Box>
    </Box>
  );
};

RequestStatusForm.defaultProps = {
  status: null
};

RequestStatusForm.propTypes = {
  status: PropTypes.string,
  isWSOwnerOrHasMRPermission: PropTypes.bool.isRequired,
  setChangedStatus: PropTypes.func.isRequired,
  statusOptions: PropTypes.array.isRequired,
  comment: PropTypes.string.isRequired,
  setComment: PropTypes.func.isRequired,
  statusConfiguration: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  setChangedStatusConfiguration: PropTypes.func.isRequired
};

export default RequestStatusForm;
